<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-row>
      <div class="vx-col w-1/4 mb-2">
        <!-- <p>dispensa:{{ dispensa.status }}</p> -->
        <!-- Chips de Status -->
        <vs-chip v-if="dispensa.status === 'created'">
          <div class="h-4 w-4 rounded-full mr-2 bg-primary"></div>
          <h6><strong>Criada</strong></h6>
        </vs-chip>

        <vs-chip v-if="dispensa.status === 'pending'">
          <div class="h-4 w-4 rounded-full mr-2 bg-primary"></div>
          <h6><strong>Pendente de Aprovação</strong></h6>
        </vs-chip>

        <vs-chip v-if="dispensa.status === 'approved'">
          <div class="h-4 w-4 rounded-full mr-2 bg-success"></div>
          <h6><strong>Aprovada</strong></h6>
        </vs-chip>

        <vs-chip v-if="dispensa.status === 'rejected'">
          <div class="h-4 w-4 rounded-full mr-2 bg-warning"></div>
          <h6><strong>Reprovada</strong></h6>
        </vs-chip>

        <vs-chip v-if="dispensa.status === 'canceled'">
          <div class="h-4 w-4 rounded-full mr-2 bg-danger"></div>
          <h6><strong>Cancelada</strong></h6>
        </vs-chip>
      </div>

      <div class="vx-col w-3/4 mb-2">
        <div class="flex flex-wrap items-center flex-start">
          <!-- Botão Submeter -->
          <vs-button
            v-if="dispensa.status === 'created'"
            size="small"
            class="mr-2"
            color="primary"
            icon-pack="feather"
            @click="
              status = 'submeted';
              saveApprove();
            "
          >
            Submeter
          </vs-button>

          <!-- Botão Aprovar -->
          <vs-button
            v-if="dispensa.status === 'pending'"
            size="small"
            class="mr-2"
            color="success"
            icon-pack="feather"
            icon="icon-check-circle"
            @click="
              status = 'approved';
              saveApprove();
            "
          >
            Aprovar
          </vs-button>

          <!-- Botão Reprovar -->
          <vs-button
            v-if="dispensa.status === 'pending'"
            size="small"
            class="mr-2"
            color="warning"
            icon-pack="feather"
            icon="icon-x-circle"
            @click="
              status = 'rejected';
              saveApprove();
            "
          >
            Reprovar
          </vs-button>

          <!-- Botão Cancelar -->
          <vs-button
            v-if="
              ['created', 'pending', 'approved', 'rejected'].includes(
                dispensa.status
              )
            "
            size="small"
            class="mr-2"
            color="danger"
            :disabled="!canAddPayroll"
            @click="
              status = 'canceled';
              saveApprove();
            "
          >
            Cancelar
          </vs-button>
        </div>
      </div>
    </vs-row>

    <vs-card>
      <div class="vx-col w-full mb-base">
        <div class="vx-row">
          <!-- Nome do trabalhador (não editável) -->
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Nome</label>
            <div class="vx-col w-full">
              <vs-input
                class="w-full"
                icon-pack="feather"
                icon="icon-user"
                icon-no-border
                :value="dispensaName + ' ' + dispensaLastName"
                disabled
              />
            </div>
          </div>

          <!-- Dedução (editável) -->
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Dedução</label>
            <div class="vx-col w-full">
              <select
                v-model="dispensa.deduct_in"
                class="w-full pl-3 pr-10 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <option value="vacation">Nas férias</option>
                <option value="salary">No salário</option>
              </select>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <!-- Data Inicial -->
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Data Inicial</label>
            <div class="vx-col w-full">
              <vs-input
                type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-calendar"
                icon-no-border
                v-model="dispensa.start_date"
              />
            </div>
          </div>

          <!-- Data Final -->
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Data Final</label>
            <div class="vx-col w-full">
              <vs-input
                type="date"
                class="w-full"
                icon-pack="feather"
                icon="icon-calendar"
                icon-no-border
                v-model="dispensa.end_date"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Hora Inicial</label>
            <div class="vx-col w-full">
              <vs-input
                type="time"
                class="w-full"
                icon-pack="feather"
                icon="icon-clock"
                icon-no-border
                v-model="dispensa.start_time"
              />
            </div>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="text-sm font-bold">Hora Final</label>
            <div class="vx-col w-full">
              <vs-input
                type="time"
                class="w-full"
                icon-pack="feather"
                icon="icon-clock"
                icon-no-border
                v-model="dispensa.end_time"
              />
            </div>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-1/2 mb-2 pr-2">
            <label class="text-sm font-bold">Descrição</label>
            <div class="vx-col w-full">
              <textarea
                class="w-full border border-solid border-gray-300 p-2 rounded"
                v-model="dispensa.reason"
                rows="4"
                style="border-color: #ccc"
              ></textarea>
            </div>
          </div>

          <div class="vx-col w-1/2 mb-2 pl-2">
            <label class="text-sm font-bold">Comprovativo</label>

            <div v-if="dispensa.attachment">
              <div class="relative p-3 border border-gray-300 rounded-md">
                <div
                  class="flex items-center text-black bg-gray-100 border border-gray-300 p-2 rounded-md shadow-sm"
                >
                  <feather-icon
                    icon="FileIcon"
                    svgClasses="w-6 h-6 mr-2 text-gray-600"
                  />
                  <span class="text-sm break-words">{{
                    getFileName(dispensa.attachment)
                  }}</span>

                  <feather-icon
                    icon="XCircleIcon"
                    svgClasses="text-gray-500 absolute bottom-0 left-0 cursor-pointer w-6 h-6"
                    @click="removeAttachment"
                  />
                </div>

                <vs-button
                  size="small"
                  color="success"
                  class="mt-3"
                  iconPack="feather"
                  icon="icon-eye"
                  target="_blank"
                  :href="dispensa.attachment"
                >
                  baixar
                </vs-button>
              </div>
            </div>

            <vs-input
              v-else
              class="w-full mt-2 mb-2"
              type="file"
              v-model="attachment"
              name="file"
              @change="previewImage"
            />
          </div>
        </div>

        <vs-button class="mr-3 mb-2" @click="saveData">Atualizar</vs-button>
      </div>

      <div
        style="height: 50px"
        id="div-with-loading"
        class="vs-con-loading__container"
      ></div>
    </vs-card>

    <!-- <vs-tabs> </vs-tabs> -->
    <div class="vx-col w-full sm:w-1/2 md:w-full mb-base">
      <vx-card title="Histórico de Aprovações">
        <!-- Aqui podemos verificar se há um histórico antes de tentar exibir -->
        <ul
          class="vx-timeline"
          v-if="aprovacaoSelecionada && aprovacaoSelecionada.length > 0"
        >
          <li
            v-for="historico in aprovacaoSelecionada"
            :key="historico.id"
            class="p-3 flex items-start space-x-5"
          >
            <!-- Ícone de Status -->
            <div v-if="historico.status === 'rejected'">
              <feather-icon
                icon="AlertCircleIcon"
                svgClasses="text-white stroke-current w-7 h-7 bg-warning p-2 rounded-full"
              />
            </div>
            <div v-if="historico.status === 'submeted'">
              <feather-icon
                icon="ArrowUpIcon"
                svgClasses="text-white stroke-current w-7 h-7 bg-primary p-2 rounded-full"
              />
            </div>
            <div v-if="historico.status === 'canceled'">
              <feather-icon
                icon="XCircleIcon"
                svgClasses="text-white stroke-current w-7 h-7 bg-danger p-2 rounded-full"
              />
            </div>
            <div v-if="historico.status === 'approved'">
              <feather-icon
                icon="CheckCircleIcon"
                svgClasses="text-white stroke-current w-7 h-7 bg-success p-2 rounded-full"
              />
            </div>

            <!-- Detalhes do Histórico -->
            <div>
              <!-- Texto de status e detalhes do usuário -->
              <p class="font-semibold text-lg">
                <!-- Aumentei o tamanho da fonte -->
                <span v-if="historico.status === 'rejected'">Reprovado</span>
                <span v-if="historico.status === 'submeted'">Submetido</span>
                <span v-if="historico.status === 'canceled'">Cancelado</span>
                <span v-if="historico.status === 'approved'">Aprovado</span>
                por {{ historico.user.name }} {{ historico.user.surname }}
              </p>

              <!-- Observação -->
              <p class="text-gray-600 text-base">
                <!-- Aumentei o tamanho da fonte -->
                {{ historico.observation }}
              </p>

              <!-- Data e Hora -->
              <small class="text-gray-500 text-sm">
                Data: {{ historico.created_at.slice(0, 10) }} às
                {{ historico.created_at.slice(11, 16) }}
              </small>
            </div>
          </li>
        </ul>
        <!-- Mensagem caso não haja histórico -->
        <p v-else>Sem histórico de aprovação.</p>
      </vx-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import http from "../../../../http-common";
import { PermissionsMixin } from "../../../mixins/permissions";
import VxTimeline from "@/components/timeline/VxTimeline.vue";

export default {
  mixins: [PermissionsMixin],
  components: {
    vSelect,
    name: "LicenceDetails",
    VxTimeline,
  },
  data() {
    return {
      attachment: null,
      showOptions: false,
      licencaId: null,
      dispensas: [],
      dispensa: {
        id: null,
        name: "",
        last_name: "",
        type: null,
        start_date: null,
        end_date: null,
        deduct_in: null,
        reason: "",
        status: "",
        employee_id: null,
        created_by: null,
        created_at: null,
        updated_at: null,
        attachment: null,
        start_time: null,
        end_time: null,
      },
      historico: [],
      aprovacaoSelecionada: [],
      aprovacao: [],
      aprovacoes: [],
      deduct_in: "",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      reason: "",
      totalPage: "",
      currentPage: "1",
      paginate: 50,
      amount: "",
      status: "",
      desconto: [],
      selectedEmployee: [],
      employees: [],
      popupAdd: false,
      popupEdit: false,
      name: "",
      abbreviation: "",
      type: "",
      components: [],
      component: [
        {
          id: "",
          name: "",
          abbreviation: "",
          type: "",
        },
      ],
      descontos: [],
      date: "",

      currentUser: [],
      dataActual: "",
      month: "",
      popupApprove: false,
    };
  },
  created() {
    // Acessa os parâmetros passados pela navegação
    this.dispensaId = this.$route.params.dispensaId;
    this.dispensaName = this.$route.params.dispensaName;
    this.dispensaLastName = this.$route.params.dispensaLastName;
  },
  mounted() {
    this.initialize();
    this.getApprove();
  },
  methods: {
    initialize() {
      this.getData();
      this.getEmployees();
      this.getApprove();
    },
    getFileName(url) {
      return url.split("/").pop().split("?")[0]; // Extrai o nome do arquivo da URL
    },
    toggleOptions() {
      this.showOptions = !this.showOptions; // Alterna a visibilidade das opções
    },
    //     isImage(url) {
    //     // Verifica se o arquivo é uma imagem (extensões simples)
    //     return /\.(jpg|jpeg|png|gif|bmp)$/i.test(url);
    //   },
    removeAttachment() {
      // Lógica para remover o anexo
      this.dispensa.attachment = null;
      //   this.showOptions = false;
    },
    getData() {
      this.$vs.loading({
        container: "#div-with-loading",
        scale: 1.0,
        type: "sound",
      });

      let token = localStorage.getItem("token");
      console.log("token:", token);

      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      http
        .get(`/attendances/waivers/${this.dispensaId}`, config)
        .then((result) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          // Armazenando os dados em 'this.dispensa'
          const dispensas = result.data.Waiver;
          console.log("Dados recebidos:", dispensas);

          // Preenchendo os campos do modelo 'dispensa'
          this.dispensa = {
            name: dispensas.name,
            last_name: dispensas.last_name,
            start_date: dispensas.start_date,
            end_date: dispensas.end_date,
            deduct_in: dispensas.deduct_in,
            reason: dispensas.reason,
            attachment: dispensas.attachment,
            start_time: dispensas.start_time,
            end_time: dispensas.end_time,
            status: dispensas.status,
          };

          // Chamar a função getApprove() após obter os dados
          this.getApprove();
        })
        .catch((error) => {
          this.$vs.loading.close("#div-with-loading > .con-vs-loading");
          if (error.response && error.response.status === 401) {
            this.$router.push("/").catch(() => {});
          } else {
            console.error("Erro ao buscar dados:", error);
          }
        });
    },

    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = () => {
          this.dispensa.attachment = reader.result; // Armazena o arquivo em binário
        };
        reader.readAsDataURL(file); // Lê o arquivo como binário
      }
    },
    previewImage(event) {
      this.dispensa.attachment = event.target.files[0];
    },
    async saveApprove() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer" + " " + token,
        },
      };
      const data = {
        status: this.status,
      };

      console.log("Status antes de enviar:", this.status);

      const requestPromise = http.post(
        `/attendances/waivers/approvals/${this.dispensaId}`,
        data,
        config
      );

      const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error("Timeout")), 2000)
      );

      Promise.race([requestPromise, timeoutPromise])
        .then(() => {
          this.$vs.loading.close();
          this.getData();
          // window.location.reload();
        })
        .catch((error) => {
          this.$vs.loading.close();

          if (error.response && error.response.status == 401) {
            this.$router.push("/").catch(() => {});
          } else {
            console.error("Erro:", error.message);
          }
        });
    },
    // saveData() {
    //   alert(3);
    // //   this.$vs.loading();
    //   let token = localStorage.getItem("token");
    //   let config = {
    //     headers: {
    //       authorization: `Bearer ${token}`,
    //       "content-type": "multipart/form-data",
    //     },
    //   };
    // //   alert(4);
    //   const formData = () => {
    //     const formData = new FormData();
    //     formData.append("start_date", this.dispensa.start_date);
    //     formData.append("start_time", "08:00");
    //     formData.append("end_date", this.dispensa.end_date);
    //     formData.append("end_time", "16:00");
    //     formData.append("type", this.dispensa.type.toString());
    //     formData.append("description", this.dispensa.description);
    //     formData.append("reason", this.reason);
    //     formData.append("deduct_in", this.deduct_in);
    //     // if (this.isNewAttachment) {
    //     //     formData.append("attachment", this.dispensa.attachment);
    //     // } else {
    //     //     formData.append("attachment", "");
    //     // }
    //     // return formData;
    //   };
    // //   alert(5);
    //   const data = formData();
    //   const url = `/attendances/waivers/update/${this.dispensaId}`;

    //   try {
    //     http.post(url, data, config);
    //     // this.popupAdd = false;
    //     // this.$vs.loading.close();
    //     // alert(6);
    //   } catch (error) {
    //     // this.$vs.loading.close();
    //   }
    // },

    async saveData() {
      // Aqui você pode enviar os dados alterados para o backend
      this.$vs.loading();

      const startTimeFormatted = this.dispensa.start_time
        .split(":")
        .slice(0, 2)
        .join(":");
      const endTimeFormatted = this.dispensa.end_time
        .split(":")
        .slice(0, 2)
        .join(":");

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
          "content-type": "multipart/form-data",
        },
      };

      const data = new FormData();
      data.append("start_date", this.dispensa.start_date);
      data.append("start_time", startTimeFormatted);
      data.append("end_date", this.dispensa.end_date);
      data.append("end_time", endTimeFormatted);
      data.append("reason", this.dispensa.reason);
      data.append("deduct_in", this.dispensa.deduct_in);
      if (this.dispensa.attachment) {
        data.append("attachment", this.dispensa.attachment);
      }
      //   data.append("attachment", this.dispensa.attachment);

      http
        .post(`/attendances/waivers/update/${this.dispensaId}`, data, config)
        .then(() => {
          this.getData();
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Sucesso",
            text: "Gravado com sucesso!",
            color: "success",
            position: "top-right",
          });
        })
        .catch((error) => {
          error;
          this.err = error.response.data;
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Erro",
            text: this.err,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right",
          });
        });
    },

    getApprove() {
      this.$vs.loading();

      let token = localStorage.getItem("token");
      let config = {
        headers: {
          authorization: "Bearer " + token,
        },
      };

      // Verifique se this.aprovacao.id está definido antes de fazer a solicitação
      if (this.dispensaId) {
        http
          .get(`/attendances/waivers/${this.dispensaId}`, config)
          .then((result) => {
            this.$vs.loading.close();
            console.log("Dados recuperados em getApprove():", result.data);
            this.aprovacaoSelecionada = result.data.Waiver.approvals.reverse();
          })
          .catch((error) => {
            error;
            if (error.response.status == 401) {
              this.$router.push("/").catch(() => {});
            }
          });
      } else {
        console.error("ID de aprovação não definido.");
        this.$vs.loading.close();
      }
    },

    converterSegundos(segundos) {
      var dias = Math.floor(segundos / (3600 * 24)); // Calcula o número de dias
      var horas = Math.floor((segundos % (3600 * 24)) / 3600); // Calcula o número de horas

      return dias + " dias e " + horas + " horas";
    },
    formatTime(time) {
      // Verificar se o valor de time está no formato correto ou apenas hora (HH:MM)
      if (time) {
        const timeParts = time.split(":"); // Divida o valor em horas e minutos

        // Se o valor já for no formato HH:MM, use diretamente
        if (timeParts.length === 2) {
          return `${timeParts[0]}:${timeParts[1]}`;
        }

        // Caso contrário, crie um objeto Date com o valor formatado
        const date = new Date(`1970-01-01T${time}`);
        if (isNaN(date)) {
          return time; // Retorna o valor original se não for uma data válida
        }

        return date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      return "";
    },
  },
};
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

.break-words {
  word-break: break-word; /* Garante quebra em palavras longas */
  white-space: normal; /* Permite múltiplas linhas */
  overflow-wrap: break-word; /* Suporte adicional para navegadores antigos */
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
